export default "__VITE_ASSET__e9be16b0__"